(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const floatingHeader = document.querySelector(".header--floating");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme = this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
			
			// Fix mobile menu accessibility for floating header
			if (floatingHeader && this.open) {
				// Menu is opening - make wrapper fixed so it doesn't push content
				header.style.position = 'fixed';
				header.style.top = '0';
				header.style.left = '0';
				header.style.right = '0';
				header.style.zIndex = '100';
				// Make the floating header sticky relative to the fixed wrapper
				floatingHeader.style.position = 'sticky';
				floatingHeader.style.top = '0';
				// Add class to remove pill styling
				floatingHeader.classList.add('menu-open');
			} else if (floatingHeader && !this.open) {
				// Menu is closing - restore floating header
				header.style.position = '';
				header.style.top = '';
				header.style.left = '';
				header.style.right = '';
				header.style.zIndex = '';
				floatingHeader.style.position = '';
				floatingHeader.style.top = '';
				// Remove class to restore pill styling
				floatingHeader.classList.remove('menu-open');
			}
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
				
				// Restore floating header on escape
				if (floatingHeader) {
					header.style.position = '';
					header.style.top = '';
					header.style.left = '';
					header.style.right = '';
					header.style.zIndex = '';
					floatingHeader.style.position = '';
					floatingHeader.style.top = '';
					// Remove class to restore pill styling
					floatingHeader.classList.remove('menu-open');
				}
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		// Fix header if window is resized from mobile to desktop while menu is open
		window.addEventListener("resize", () => {
			const isDesktop = window.innerWidth >= 1100;
			if (isDesktop && floatingHeader) {
				// Close the menu drawer if it's open
				if (headerDetails.open) {
					headerDetails.open = false;
				}
				
				// Remove overflow classes from body
				body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-mobile');
				
				// Reset all inline styles if we're on desktop
				header.style.position = '';
				header.style.top = '';
				header.style.left = '';
				header.style.right = '';
				header.style.zIndex = '';
				floatingHeader.style.position = '';
				floatingHeader.style.top = '';
				floatingHeader.classList.remove('menu-open');
			}
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();

	// When child menu items extend beyond the container, need to change the childmenue opening direction.
	const headerSubMenu = () => {
		const dir = document.querySelector('html').getAttribute("dir");
		const listMenu = document.querySelector(".header__menu .list-menu");
		const listMenuRect = listMenu.getBoundingClientRect();

		const allSubmenus = listMenu.querySelectorAll(".header__submenu .list-menu-has-child .header__submenu")
		allSubmenus.forEach(item => {
			const itemRect = item.getBoundingClientRect();
			if(dir === "ltr"){
				if(itemRect.right > listMenuRect.right){
					item.style.left = "auto";
					item.style.right = "100%";
				}
			} else {
				if(itemRect.left < listMenuRect.left){
					item.style.left = "100%";
					item.style.right = "auto";
				}
			}
		});
	}

	headerSubMenu();
})();
